import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface SkeletonCardProps {
  rows?: number;
  height?: string;
  title?: string;
  showHeader?: boolean;
  columns?: number;
  columnSizes?: string[];
}

const SkeletonCard: React.FC<SkeletonCardProps> = ({
  rows = 3,
  height = '200px',
  showHeader = true,
  columns = 2,
  columnSizes
}) => {
  return (
    <Card className="skeleton-card">
      {showHeader && (
        <CardHeader className="flex justify-between items-center">
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-4 w-1/4" />
        </CardHeader>
      )}
      <CardContent>
        <div className="space-y-4">
          {Array.from({ length: rows }).map((_, index) => (
            <div key={index} className="grid grid-cols-2 gap-4">
              {Array.from({ length: columns }).map((_, colIndex) => (
                <div key={colIndex}>
                  <Skeleton className="h-4 w-full" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default SkeletonCard;
